import { getCookie } from '@/modules/services/cookies'

export function setCartHeaders (token) {
  return {
    ...(token === false
      ? {}
      : { 'X-Cart-Token': token || getCookie('cart-token') })
  }
}
